export const AUTOCOMPLETE_HAS_ERRORED = "AUTOCOMPLETE_HAS_ERRORED";
export const AUTOCOMPLETE_IS_LOADING = "AUTOCOMPLETE_IS_LOADING";
export const AUTOCOMPLETE_FETCH_DATA_SUCCESS = "AUTOCOMPLETE_FETCH_DATA_SUCCESS";
export const AUTOCOMPLETE_IS_SELECTED = "AUTOCOMPLETE_IS_SELECTED";
